const RoleManage = () => import(/* webpackChunkName: 'access' */ './roleManage');
const UserManage = () => import(/* webpackChunkName: 'access' */ './userManage');
const CreateUser = () => import(/* webpackChunkName: 'access' */ './createUser');
const UserDetail = () => import(/* webpackChunkName: 'access' */ './userDetail');
const LogList = () => import(/* webpackChunkName: 'access' */ './logList');
const RoleDetail = () => import(/* webpackChunkName: 'access' */ './roleDetail');
const RoleLogList = () => import(/* webpackChunkName: 'access' */ './roleLogList');
const RoleCreate = () => import(/* webpackChunkName: 'access' */ './roleCreate');
const OrgManage = () => import(/* webpackChunkName: 'access' */ './orgManage');
const RoleUpdate = () => import(/* webpackChunkName: 'access' */ './roleUpdate');
const RoleCopy = () => import( /* webpackChunkName: 'access' */ './roleCopy');
const Business = () => import(/* webpackChunkName: 'access' */ './1');
const Type = () => import(/* webpackChunkName: 'access' */ './2');
const Introduce = () => import(/* webpackChunkName: 'access' */ './3');
const SupOrgManage = () => import(/* webpackChunkName: 'access' */ './supOrgManage');
const BatchAddition = () => import(/* webpackChunkName: 'access' */ './batchAddition');

const routes = [
  { path: '/access/roleManage', component: RoleManage, meta: { isKeepAlive: true } },
  {
    path: '/access/userManage',
    component: UserManage, meta: { isKeepAlive: true }
  },
  { path: '/access/createUser', component: CreateUser, meta: { isKeepAlive: true } },
  { path: '/access/userDetail', component: UserDetail, meta: { isKeepAlive: true } },
  { path: '/access/logList', component: LogList, meta: { isKeepAlive: true } },
  { path: '/access/roleDetail', component: RoleDetail, meta: { isKeepAlive: true } },
  { path: '/access/roleLogList', component: RoleLogList, meta: { isKeepAlive: true } },
  { path: '/access/roleCreate', component: RoleCreate, meta: { isKeepAlive: true } },
  { path: '/access/roleUpdate', component: RoleUpdate, meta: { isKeepAlive: true } },
  { path: '/access/roleCopy', component: RoleCopy, meta: { isKeepAlive: true } },
  { path: '/access/orgManage', component: OrgManage, meta: { isKeepAlive: true } },
  { path: '/business/overview', component: Business, meta: { isKeepAlive: true } },
  { path: '/type/overview', component: Type },
  { path: '/type/introduce', component: Introduce },
  { path: '/access/supOrgManage', component: SupOrgManage, meta: { isKeepAlive: true } },
  { path: '/access/batchAddition', component: BatchAddition } // 批量添加项目所属组织机构
];

export default routes;
